<template lang="pug">
  .next-sub-shipment(data-mr-ass="your-subscription")
    SectionTitle(:text="subscriptionTitle" data-mr-ass="also-in-box-next-order").text-center
    InvoiceStatusBar(v-if="preparing" status="preparing")

    .next-sub
      .row.next-date.md-hide.lg-hide(v-if="refillCart.nextShipment")
        .xs-12.xs-f-xsmall.lg-f-small.max-at-tweak.upper.upper.color-slate next shipment&nbsp;
        .xs-12.xs-f-medium.lg-f-xmedium.max-at-tweak.bold {{ refillCart.nextShipment.next | moment('MMMM D') }}

      template(v-if="refillCart.nextShipment")
        InvoiceWithActionsLayout
          template(#items="")
            InvoiceItem(v-for="item in refillCartItems" :item="item" :key="item.id" data-mr-ass="added-to-order-name").xs-12
              template(#top="" v-if="showItemControls(item)")
                ConfirmDialog(@confirm="removeItem(item)" confirm-text="Remove" title="Remove item" :text="removeText(item)")
                  button.remove-item.transparent-btn.xs-f-large.max-at-tweak(type="button" data-mr-ass="remove-xsell-button")
                    span.icon-x.clickable
                    span.ada-tooltip Remove item

              template(#bottom="")
                .qty-edit.xs-12
                  template(v-if="showItemControls(item)")
                    span.xs-f-xsmall.max-at-tweak.upper qty:
                    QtyButtons(:qty="item.qty" @qtyChange="onQtyChange(item, ...arguments)")

                  template(v-else-if="showSubQty(item)")
                    span.xs-f-xsmall.max-at-tweak.upper qty: {{ item.qty }}

          template(#totals="")
            .next-date.xs-hide.sm-hide(v-if="refillCart.nextShipment")
              span.xs-f-xsmall.lg-f-small.max-at-tweak.upper.upper.color-slate next shipment&nbsp;
              span.xs-f-medium.lg-f-xmedium.max-at-tweak.bold(data-mr-ass="next-date") {{ refillCart.nextShipment.next | moment('MMMM D') }}

            template(v-if="nextShipmentTotal")
              span.xs-f-xsmall.lg-f-small.max-at-tweak.upper.color-slate Subtotal
              span.md-hide.lg-hide :&nbsp;
              span.xs-f-medium.lg-f-xmedium.max-at-tweak.bold(data-mr-ass="subtotal-next-order") {{ nextShipmentTotal | currency }}

          template(#ctas="")
            template(v-if="refillCart.nextShipment")
              button.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:class="{ disabled: shipNowDisabled }" @click="shipNow({ subId: refillCart.nextShipment.sub_id })") Ship Now
              router-link.mr-btn.btn-block.btn-inverse.xs-f-xsmall.max-at-tweak(:to="`/dashboard/purchases/edit-auto-delivery/${ refillCart.nextShipment.sub_id }`") Manage Subscription

      template(v-else-if="reactivateTheSub.id")
        InvoiceWithActionsLayout
          template(#items="")
            InvoiceItem(:item="reactivateTheSub.product_info" :key="1").xs-12

          template(#totals="")
            .xs-f-xsmall.lg-f-small.max-at-tweak.upper.color-slate Subscription stopped on
            .xs-f-medium.lg-f-xmedium.max-at-tweak.bold {{ reactivateTheSub.last_canceled_at | moment('MMM D, YYYY') }}

          template(#ctas="")
            router-link.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:to="`/dashboard/purchases/edit-auto-delivery/${ reactivateTheSub.id }`") Reactivate

</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import HeroProduct from "../HeroProduct";
  import SectionTitle from "../../../../SectionTitle";
  import InvoiceStatusBar from "../InvoiceStatusBar";
  import ProductInfoImage from "../../../Purchases/ProductInfoImage";
  import ConfirmDialog from "../../../../ConfirmDialog";
  import Pill from "../../../../Pill";
  import QtyButtons from "../../../../QtyButtons";
  import InvoiceWithActionsLayout from "../InvoiceWithActionsLayout";
  import InvoiceItem from "../InvoiceItem/InvoiceItem";
  import { getObjProperty } from "../../../../../utilities/mrVueUtils";

  export default {
    name: "WelcomeNextShipment",
    components: {
      InvoiceItem,
      InvoiceWithActionsLayout,
      QtyButtons,
      Pill,
      ConfirmDialog,
      ProductInfoImage,
      InvoiceStatusBar,
      SectionTitle,
      HeroProduct
    },

    data() {
      return {
        ctaSource: 'rcdWelcomeNextShipment'
      }
    },

    computed: {
      ...mapState('refillCart', [
        'refillCart',
        'loadingRefillCart',
        'modifyingRefillProduct'
      ]),

      ...mapGetters('refillCart', ['refillCartItems']),
      ...mapGetters('subscriptions', ['inactiveSubs']),

      nextShipmentTotal() {
        let subTotal = getObjProperty(this, 'refillCart.totals.displaySubtotal') || 0;
        let discount = getObjProperty(this, 'refillCart.totals.discount') || 0;
        return subTotal + discount;
      },

      shipNowDisabled() {
        return this.modifyingRefillProduct || this.loadingRefillCart;
      },

      preparing() {
        if (!this.refillCart || !this.refillCart.nextShipment) {
          return false;
        }

        let nextShipDate = this.$moment(this.refillCart.nextShipment.next);
        let today = this.$moment();

        return nextShipDate.diff(today, 'days') < 10;
      },

      subscriptionTitle() {
        if (!this.refillCart || !this.refillCart.subscriptionsInCart) {
          return;
        }

        let primarySubsInNextShipment = this.refillCart.subscriptionsInCart.filter(sub => sub.subscription && !sub.isAttachment);
        return `Your subscription${primarySubsInNextShipment.length > 1 ? 's' : ''}`;
      },

      reactivateTheSub() {
        let reactivate = {};

        if (!this.loadingRefillCart && !this.refillCart.nextShipment && this.inactiveSubs.length) {
          reactivate = this.inactiveSubs[0];
        }

        return reactivate;
      }
    },

    methods: {
      ...mapActions('refillCart', [
        'initRefillCart',
        'loadRefillCart',
        'updateRefillItemQty',
        'removeRefillItem'
      ]),

      ...mapActions('subscriptions', [
        'removeSubAttachment',
        'updateSubAttachmentQty',
        'shipNow'
      ]),

      showItemControls(item) {
        return !item.subscription && item.qty;
      },

      showSubQty(item) {
        return item.subscription && item.qty > 1;
      },

      removeText(item) {
        let subAddOnText = "Your item will be removed from this shipment and all upcoming shipments. Do you want to continue?";
        let addOnText = "Are you sure you want to remove this item from your next shipment?";
        return item.sub_id ? subAddOnText : addOnText;
      },

      onQtyChange(item, qty) {
        if (!qty) {
          return;
        }

        if (item.isAttachment) {
          let payload = {
            sub_id: item.subscription_id,
            attachment_id: item.id,
            qty
          };

          this.updateSubAttachmentQty(payload).finally(this.loadRefillCart);

        } else {
          let payload = {
            subscriptionId: this.refillCart.nextShipment.sub_id,
            index: item.index,
            qty,
            ctaSource: this.ctaSource,
            product_id: item.id
          };

          this.updateRefillItemQty(payload);
        }

      },

      removeItem(item) {
        if (item.isAttachment) {
          let payload = {
            sub_id: item.subscription_id,
            attachment_id: item.id
          };

          this.removeSubAttachment(payload).finally(this.loadRefillCart);

        } else {
          let payload = {
            subscriptionId: this.refillCart.nextShipment.sub_id,
            index: item.index,
            ctaSource: this.ctaSource,
            product_id: item.id
          };

          this.removeRefillItem(payload);
        }
      }
    },

    mounted() {
      this.loadRefillCart();
    }
  }
</script>

<style scoped lang="stylus">
  .next-sub-shipment
    overflow visible !important

    .section-title
      padding 1em

    .invoice-progress
      padding-bottom 1em

    .next-sub
      > div
        padding 0 2em 1.5em

      &:not(:last-child)
        padding-bottom 2em
        margin-bottom 1.5em
        border-bottom 1px solid color-fog-light

    .remove-item
      z-index 10
      top 0
      right 0
      padding 0
      position absolute
      color color-gray-triple-nines

    .inactive
      padding 1.5em 1em 2em 1em
      margin-top 2em
      background-color color-mr-blue-light

      p
        margin-bottom 1.5em

    .qty-edit
      margin-top 1em
      > *
        display inline-block

      > span
        padding-right 0.8em

    @media mq-mobile
      .next-sub
        padding 0

      .edit-wrap
        float right

    @media mq-tablet
      .next-sub
        padding 0

    @media mq-desktop-md
      .next-date
        margin-bottom 1em

      .remove-item
        top 0.3em
        right 0.3em
        background-color #fff
        border-radius 50%

    @media mq-desktop-plus
      .next-date
        margin-bottom 1em

      .remove-item
        top 0.3em
        right 0.3em
        background-color #fff
        border-radius 50%

</style>
